import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { notification } from 'antd';
import { I18n } from '@aws-amplify/core';

import { Service } from '@/infra/services/bera';
import { BeraReportResult } from '@/types/Bera';

export interface GetReportResultParams {
	organization_id: string;
	company_id: string;
	file_id: string;
	bera_job_summary_id: string;
}

export type GetReportResultResponse = BeraReportResult;

export const useGetReportResult = () => {
	return useMutation<GetReportResultResponse, AxiosError<Response>, GetReportResultParams>(
		(params: GetReportResultParams) => Service.getReportResult(params),
		{
			onError: (err: any) => {
				const typeError = err.response.data.details[0]?.split('" ') ?? err;
				notification.error({
					message: I18n.get('Ops... something happened!'),
					description: I18n.get(typeError[1])
				});
			}
		}
	);
};
